/**
 * Resolves variant cost for Pricing UI.
 * DB stores `cost` (number); UI expects Shopify-shaped `unitCost: { amount }`.
 */
export function getVariantUnitCost(variant) {
  if (!variant) return null;
  if (variant.unitCost != null) return variant.unitCost;
  if (variant.cost != null) return { amount: variant.cost };
  return null;
}
